// import React, { useEffect, useState } from 'react';
// import './Analysis.css';
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
//   BarChart,
//   Bar,
// } from "recharts";
// import axios from 'axios';

// const BasicReport = () => {
//   const [orders, setOrders] = useState([]);
//   const [vendorId, setVendorId] = useState(null);
//   const [paymentData, setPaymentData] = useState([]);
//   const isMobile = window.innerWidth <= 768;
//   const [loading, setLoading] = useState(true); // 👈 Loader state
//   const[ activeTab, setActiveTab]= useState(null);

//   const [orderCounts, setOrderCounts] = useState({
//     Food: 0,
//     Rooms: 0,
//     "Banquet Halls": 0,
//     Fashion: 0,
//   });

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 3000); // 👈 Show loader for 4 seconds
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) setVendorId(storedVendorId);
//   }, []);

//   useEffect(() => {
//     const fetchTodayOrders = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const res = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const allOrders = res.data;
//         const today = new Date().toISOString().split("T")[0];
//         const counts = { Food: 0, Rooms: 0, "Banquet Halls": 0, Fashion: 0 };

//         allOrders.forEach((order) => {
//           const orderDate = new Date(order.orderDateAndTime).toISOString().split("T")[0];
//           if (
//             orderDate === today &&
//             order.status === "COMPLETED" &&
//             counts.hasOwnProperty(order.appType)
//           ) {
//             counts[order.appType]++;
//           }
//         });
//         setOrderCounts(counts);
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };

//     if (vendorId) fetchTodayOrders();
//   }, [vendorId]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const res = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const orders = res.data;
//         const methodCount = {};
//         orders.forEach(order => {
//           const method = order.paymentMethod || 'Unknown';
//           methodCount[method] = (methodCount[method] || 0) + 1;
//         });

//         const total = orders.length;
//         const chartData = Object.keys(methodCount).map(method => ({
//           name: method,
//           value: methodCount[method],
//           percent: (methodCount[method] / total) * 1,
//         }));

//         setPaymentData(chartData);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     if (vendorId) fetchData();
//   }, [vendorId]);

//   const COLORS1 = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28BFE'];
//   const [monthlyData, setMonthlyData] = useState([]);

//   const topItems = [
//     { name: "Chicken Biryani", orders: 240 },
//     { name: "Paneer", orders: 180 },
//     { name: "Paneer Butter", orders: 170 },
//   ];

//   useEffect(() => {
//     const fetchMonthlyData = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const orders = response.data;
//         const groupedData = {};

//         orders.forEach((order) => {
//           const date = new Date(order.orderDateAndTime);
//           const month = date.toLocaleString("default", { month: "short", year: "numeric" });

//           if (!groupedData[month]) {
//             groupedData[month] = { month, Orders: 0, Revenue: 0 };
//           }
//           groupedData[month].Orders += 1;
//           groupedData[month].Revenue += order.totalAmount || 0;
//         });

//         const sortedData = Object.values(groupedData);
//         setMonthlyData(sortedData);
//       } catch (error) {
//         console.error("Error fetching monthly data:", error);
//       }
//     };

//     if (vendorId) fetchMonthlyData();
//   }, [vendorId]);

//   const [revenueBreakdown, setRevenueBreakdown] = useState({ Food: 0 });

//   useEffect(() => {
//     if (!vendorId) return;
//     const fetchTodayRevenue = async () => {
//       try {
//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`
//         );

//         const allOrders = response.data;
//         const today = new Date().toISOString().split("T")[0];
//         const todayOrders = allOrders.filter((order) =>
//           order.orderDateAndTime?.startsWith(today)
//         );

//         const revenueByAppType = { Food: 0 };
//         let total = 0;

//         todayOrders.forEach((order) => {
//           const amount = order.totalAmount || 0;
//           if (revenueByAppType.hasOwnProperty(order.appType)) {
//             revenueByAppType[order.appType] += amount;
//             total += amount;
//           }
//         });

//         const percentageBreakdown = {};
//         for (let key in revenueByAppType) {
//           percentageBreakdown[key] = total
//             ? ((revenueByAppType[key] / total) * 100).toFixed(1)
//             : 0;
//         }

//         setRevenueBreakdown(percentageBreakdown);
//       } catch (error) {
//         console.error("Error fetching today's revenue:", error);
//       }
//     };
//     fetchTodayRevenue();
//   }, [vendorId]);

//   const [customerCounts, setCustomerCounts] = useState({
//     Food: 0,
//     Rooms: 0,
//     Banquet: 0,
//     Fashion: 0,
//   });

//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchTodayCustomers = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const res = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const today = new Date().toISOString().split("T")[0];
//         const todayOrders = res.data.filter((order) => {
//           const orderDate = new Date(order.orderDateAndTime).toISOString().split("T")[0];
//           return orderDate === today;
//         });

//         const counts = { Food: 0, Rooms: 0, Banquet: 0, Fashion: 0 };

//         todayOrders.forEach((order) => {
//           const appType = order.appType;
//           if (appType === "Food") counts.Food++;
//           else if (appType === "Room") counts.Rooms++;
//           else if (appType === "Banquet") counts.Banquet++;
//           else if (appType === "Fashion") counts.Fashion++;
//         });

//         setCustomerCounts(counts);
//       } catch (error) {
//         console.error("Error fetching customer counts:", error);
//       }
//     };

//     fetchTodayCustomers();
//   }, [vendorId]);

//   const [successRates, setSuccessRates] = useState({ Food: 0 });

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const orders = response.data;
//         const today = new Date().toISOString().split("T")[0];
//         const todayOrders = orders.filter(order =>
//           new Date(order.orderDateAndTime).toISOString().split("T")[0] === today
//         );

//         const rates = {};
//         const categories = ["Food"];
//         categories.forEach((category) => {
//           const catOrders = todayOrders.filter(o => o.appType === category);
//           const total = catOrders.length;
//           const success = catOrders.filter(o => o.status === "COMPLETED").length;
//           rates[category] = total ? ((success / total) * 100).toFixed(1) : 0;
//         });

//         setSuccessRates(rates);
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };

//     if (vendorId) fetchOrders();
//   }, [vendorId]);

//   if (loading) {
//     return (
//       <div
//         style={{
//           height: '500px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexDirection: 'column',
//           fontSize: '24px',
//           fontWeight: 'bold',
//         }}
//       >
//         {/* <div style={{ marginBottom: '10px' }}>Loading</div> */}
//         <div style={{ display: 'flex', gap: '10px' }}>
//           {[0, 1, 2].map((i) => (
//             <div
//               key={i}
//               style={{
//                 width: '12px',
//                 height: '12px',
//                 borderRadius: '50%',
//                 backgroundColor: '#8884d8',
//                 animation: `pulse 1.5s ${i * 0.2}s infinite ease-in-out`,
//                 opacity: 0.5,
//               }}
//             />
//           ))}
//         </div>

//         {/* Inline keyframes */}
//         <style>
//           {`
//           @keyframes pulse {
//             0% {
//               transform: scale(1);
//               opacity: 0.5;
//             }
//             50% {
//               transform: scale(1.5);
//               opacity: 1;
//             }
//             100% {
//               transform: scale(1);
//               opacity: 0.5;
//             }
//           }
//         `}
//         </style>
//       </div>
//     );
//   }

//   const tabContent = {
//   }

//   return (

//     <div
//       className="cardcolumn"
//       style={{
//         overflowY: "auto",
//         height: isMobile ? "700px" : "550px",
//         marginTop: "30px",
//         scrollbarWidth: "none",
//       }}
//     >

//       {/* Tab Buttons */}
//       <div className='cardcolumn' style={{ gap: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
//         {Object.keys(tabContent).map((label) => (
//           <button
//             key={label}
//             onClick={() => setActiveTab(label)}
//             style={{
//               border: 'none',
//               borderRadius: '10px',
//               width: '100px',
//               height: '40px',
//               backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
//               color: '#000',
//               fontWeight: 'bold',
//               cursor: 'pointer',
//               transition: 'background-color 0.3s ease',
//             }}
//           >
//             {label}
//           </button>
//         ))}

//       </div>

//       {/* Tab Content */}
//       <div className='cardcolumn' style={{ marginTop: '-20px', padding: '20px', borderRadius: '8px', }}>
//         <div>
//           <div className="status-overview4">
//             <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//               <h3 style={{ display: 'flex', justifyContent: "center" }}>Total Orders</h3>
//               <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Food: {orderCounts.Food}</p>
//             </div>
//             <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//               <h3 style={{ display: "flex", justifyContent: "center" }}>Total Revenue</h3>
//               {Object.entries(revenueBreakdown).map(([type, percent]) => (
//                 <p
//                   key={type}
//                   style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}
//                 >
//                   {type}: {percent}%
//                 </p>
//               ))}
//             </div>

//             <div
//               style={{ background: "gray", color: "#fff" }}
//               className="status-card4"
//             >
//               <h3 style={{ display: "flex", justifyContent: "center" }}>
//                 Total Customers
//               </h3>
//               <p style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
//                 Food: {customerCounts.Food}
//               </p>

//             </div>

//             <div className="status-overview4">
//               <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//                 <h3 style={{ display: 'flex', justifyContent: "center" }}>Success rate</h3>
//                 {Object.entries(successRates).map(([category, rate]) => (
//                   <p
//                     key={category}
//                     style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}
//                   >
//                     {category}: {rate}%
//                   </p>
//                 ))}
//               </div>

//             </div>
//           </div>


//         </div>
//       </div>
//       <div>
//         <div
//           className="cardcolumn"
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             gap: "16px",
//           }}
//         >
//           <div
//             style={{
//               padding: "16px",
//               flex: "1 1 48%",
//               minWidth: "300px",
//               maxWidth: "48%",
//             }}
//           >
//             <h2
//               style={{
//                 fontSize: "24px",
//                 fontWeight: "bold",
//                 color: "red",
//                 marginBottom: "16px",
//                 marginLeft: "50px",
//               }}
//             >
//               Monthly Orders & Revenue
//             </h2>
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart
//                 data={monthlyData}
//                 margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="month" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="Orders" fill="#1f77b4" />
//                 <Bar dataKey="Revenue" fill="#d62728" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>

//           <div
//             style={{
//               padding: "16px",
//               flex: "1 1 48%",
//               minWidth: "300px",
//               maxWidth: "48%",
//             }}
//           >
//             <h2
//               style={{
//                 fontSize: "24px",
//                 fontWeight: "bold",
//                 color: "red",
//                 marginBottom: "16px",
//                 marginLeft: "50px",
//               }}
//             >
//               Top 3 Selling Items
//             </h2>
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart
//                 data={topItems}
//                 margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
//               >
//                 <CartesianGrid strokeDasharray="2 2" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="orders" fill="#1f77b4" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//         <div className='cardcolumn' style={{ display: "flex", justifyContent: "space-evenly" }}>

//           <div>
//             <div style={{ padding: "16px", textAlign: "center" }}>
//               <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px" }}>
//                 Most Preferred Payment
//               </h2>
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie
//                     data={paymentData}
//                     cx="52%"
//                     cy="40%"
//                     outerRadius={80}
//                     fill="#8884d8"
//                     dataKey="value"
//                     label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
//                   >
//                     {paymentData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS1[index % COLORS1.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                   <Legend />
//                 </PieChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </div>
//       </div>


//     </div>
//   );
// };

// const tableHeaderStyle = {
//   padding: '12px',
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   fontWeight: 'bold',
//   backgroundColor: '#b15cd6',
//   color: 'white',
// };

// const tableCellStyle = {
//   padding: '12px',
//   border: '1px solid #ddd',
//   textAlign: 'center',
// };

// const evenRowStyle = {
//   backgroundColor: '#f9f9f9',
// };

// const oddRowStyle = {
//   backgroundColor: '#fff',
// };
// const inputStyle = {
//   width: '100%',
//   border: 'none',
//   backgroundColor: 'transparent',
//   textAlign: 'center',
// };

// export default BasicReport;






import React, { useEffect, useState } from "react";
import "./Analysis.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
} from "recharts";
import axios from "axios";

const BasicReport = () => {
  const [vendorId, setVendorId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const isMobile = window.innerWidth <= 768;
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28BFE"];

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const res = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setData(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching report:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorId]);

  if (loading) {
    return (
      <div
        style={{
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!data) {
    return <div>No Data Found</div>;
  }

  // ✅ Transform API response for charts
  const paymentData = data.paymentDistribution.map((p) => ({
    name: p.method,
    value: p.count,
    percent: parseFloat(p.percentage),
  }));

  const topItems = data.topSellingItems.map((item) => {
    const key = Object.keys(item)[0];
    return { name: key, orders: item[key] };
  });

  const monthlyData = [
    {
      month: "This Week",
      Orders: data.weeklyOrders,
      Revenue: data.weeklyRevenue,
    },
    {
      month: "Today",
      Orders: data.dailyOrders,
      Revenue: data.dailyRevenue,
    },
  ];

  return (
    <div
      className="cardcolumn"
      style={{
        overflowY: "auto",
        height: isMobile ? "700px" : "550px",
        marginTop: "30px",
        scrollbarWidth: "none",
      }}
    >
      {/* Status Cards */}
      <div className="status-overview4">
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Orders</h3>
          <p>{data.totalOrders}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Revenue</h3>
          <p>₹{data.totalRevenue}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Customers</h3>
          <p>{data.totalCustomers}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Success Rate</h3>
          <p>{data.successRate}</p>
        </div>
      </div>

      {/* Charts */}
      <div
        className="cardcolumn"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "16px",
          marginTop: "20px",
        }}
      >
        {/* Orders & Revenue */}
        <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "red",
              marginBottom: "16px",
            }}
          >
            Orders & Revenue
          </h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Orders" fill="#1f77b4" />
              <Bar dataKey="Revenue" fill="#d62728" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Top Selling Items */}
        <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "red",
              marginBottom: "16px",
            }}
          >
            Top Selling Items
          </h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={topItems}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="orders" fill="#1f77b4" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Payment Distribution */}
      <div style={{ padding: "16px", textAlign: "center" }}>
        <h2
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "red",
            marginBottom: "16px",
          }}
        >
          Payment Distribution
        </h2>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={paymentData}
              cx="50%"
              cy="50%"
              outerRadius={100}
              dataKey="value"
              label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
            >
              {paymentData.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BasicReport;
